import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    AdditionalFeesStatus,
    ContractCurrency,
} from 'app/enums/label.enums'
import {
    AlLogisticPricing,
} from './AlLogisticPricing.types'

const config: SkyNetTableConfig<keyof AlLogisticPricing> = {
    name: 'AlLogisticPricing',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'airlineName',
                filterField: 'airlineName',
                labelKey: 'Opportunity.airline',
                filterType: FilterType.Array,
                reduced: true,
            },
            {
                name: 'currency',
                labelKey: 'LaneOpsInformationDto.currency',
                componentName: 'EnumValue',
                allowedValuesEnum: ContractCurrency,
                filterField: 'currency',
                filterType: FilterType.Array,
                reduced: true,
            },
            {
                name: 'status',
                labelKey: 'LaneBaseDto.laneStatus',
                filterField: 'status',
                componentName: 'EnumValue',
                allowedValuesEnum: AdditionalFeesStatus,
                filterType: FilterType.Array,
                reduced: true,
            },
            {
                name: 'validFrom',
                labelKey: 'LaneFeesUpdateDto.validFrom',
                filterField: 'validPricingFrom',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
            },
            {
                name: 'validTo',
                filterField: 'validTo',
                labelKey: 'LaneFeesUpdateDto.validTo',
                filterType: FilterType.DateRange,
                componentName: 'LaneDateEnriched',
            },
        ],
    }],
}

export default config
